import { computed } from 'vue'
import { useUserStore } from '@/store/user'
import { hasPermission } from '@/utils/permission'

/**
 * 响应式判断当前用户是否具备某 RBAC 权限 key。
 */
export function usePermissionKey(permissionKey) {
  const userStore = useUserStore()
  return computed(() => hasPermission(userStore.user, permissionKey))
}
